export const BRT_TEHRAN_LIGHT_IMAGE =
  'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/brt_map_tehran_march_6_2022.svg';
export const BRT_TEHRAN_NIGHT_IMAGE =
  'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/brt_map_tehran_night_march_6_2022.svg';

export const BRT_TABRIZ_LIGHT_IMAGE =
  'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/brt_map_tabriz_march_6_2022.svg';
export const BRT_TABRIZ_NIGHT_IMAGE =
  'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/brt_map_tabriz_night_march_6_2022.svg';
